var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagOfAland({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 340,
    viewBox: "0 0 52 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h52v34H0Z",
    fill: "#0064AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17h52M21 0v34",
    strokeWidth: 10,
    stroke: "#FFD300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17h52M21 0v34",
    strokeWidth: 4,
    stroke: "#DA0E15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfAland);
export default __webpack_public_path__ + "static/media/flag_of_aland.ef2b10c06b1934b2bf5080223e2049bf.svg";
export { ForwardRef as ReactComponent };